import React from 'react';
import PropTypes from 'prop-types';

import { SingleFieldForm } from 'inside-out/components/shared/singleFieldForm';
import MagnifyingGlassIcon from 'inside-out/components/shared/icons/magnifyingGlassIcon';


export const SearchFilter = ({ placeholder, value, onChange, onSubmit }) => (
  <SingleFieldForm
    onSubmit={ e => {
      e.preventDefault();
      onSubmit();
    } }
    onChange={ e => onChange(e.target.value) }
    placeholderText={placeholder}
    value={ value }
    buttonContent={ <MagnifyingGlassIcon /> }
    inputWidth={ 404 }/>
);

SearchFilter.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/resource-library/searchFilter/component.js